import { Table } from '@/shared/MwsViewModels';
import { Vue, Component, Prop } from 'vue-property-decorator';
import template from './canada-distribution-table.vue';

@Component({
  mixins: [template]
})
export default class CanadaDistributionTable extends Vue {
  @Prop()
  table: Table;
}
